import { Badge, Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";

function BasicTabs({ tabs, status, setStatus }) {
  const StyledTabs = styled(Tabs)({
    borderBottom: "1px solid #e8e8e7",
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    backgroundColor:"unset",
  });
  const StyledTab = styled(Tab)({

    "&:hover": {
      backgroundColor:"lavender"
    },
    "&.Mui-selected": {
      fontWeight: "bold",
      //borderRadius: 0,
      //borderBottom: "5px solid lightsalmon",
      border:"2px solid #1A73E8",
      backgroundColor:"lavender"
    },
  });
  return (
    <StyledTabs sx={{padding:".1rem"}} value={status} onChange={(e,v)=>{setStatus(v)}}>
      {tabs.map((tab, index) => (
        <StyledTab
          key={index}
          sx={{margin:"0 5px 0 0",border:"1px solid #004cff",borderRadius:".25rem"}}
          value={tab.label}
          label={
            <>
              <span style={{marginRight:".2rem"}}>{tab.label}</span>
              {/* <Badge color="info" max={tab.count + 1} badgeContent={tab.count.toString()} /> */}
              <div style={{background:"#1A73E8",padding:"0 6px",fontSize:"0.75rem",fontWeight:"600",color:"white",borderRadius:"10px", height:"20px"}}>{tab.count.toString()}</div>
            </>
          }
        />
      ))}
    </StyledTabs>
  );
}

export default BasicTabs;
